<template>
    <div class="start">
        <div class="downLogos clearfix">
            <img src="http://weddingimg-oss.tvunetworks.cn/weddinglive-image/20190730/e6d9007f436b44479c5c48f23820b9e7.png" alt="">
            <a class="colorccc f_r" @click="signIn">Sign In</a>
        </div>
        <div class="content clearfix">
            <div class="link">
                <div class="title">
                    TVU Search
                </div>
                <div class="nextTitle">
                    Preview newsroom feeds ANYWHERE
                </div>
                <p>
                    <i class="el-icon-check"></i>
                    LIVE video previews of feeds available on TVU Global Grid
                </p>
                <p>
                    <i class="el-icon-check"></i>
                    Rich METADATA about the live content
                </p>
                <p>
                    <i class="el-icon-check"></i>
                    FREE service
                </p>
                <p>
                    <i class="el-icon-check"></i>
                    Accessible from your PC & Mobile Devices
                </p>
                <div class="start-btn" @click="goAccount">
                    Get Started Now!
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { gaAnalyze } from '@/assets/js/googleAnalyze/event.js';
export default {
    data(){
        return{
            ifSafari:false,
            linkWidth: $('.link').width(),
            showDownload:false,
            timeOut:null
        }
    },
    created(){
        let u = navigator.userAgent; //取得浏览器的userAgent字符串
        // let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if(isiOS) {
            this.ifSafari = true;
        }else{
            this.ifSafari = false;
        }
    },
    mounted(){
        // if(this.timeOut) clearInterval(this.timeOut)
        // this.timeOut = setInterval(()=>{
        //     this.linkWidth = $('.link').width();
        //     let width = this.linkWidth/100 + 'rem';
        //     $(".downLogo").css("width", width);
        // },1000)

        // window.onresize = () => {
        //     return (() => {
        //         this.linkWidth = $('.link').width();
        //         let width = this.linkWidth/100 + 'rem';
        //         $(".downLogo").css("width", width);
        //     })()
        // }

    },
    // watch: {
    //     linkWidth (val) {
    //         if(val){
    //             console.info(773,val);
    //             this.linkWidth = $('.link').width();
    //             let width = this.linkWidth/100 + 'rem';
    //             $(".downLogo").css("width", width);
    //             this.showDownload = true;
    //         }
    //         console.info(73,val);
    //     }
    // },
    methods:{
        goAccount(){
            gaAnalyze('lpStartSignIn');
            // this.$router.push({name:'account',query:{type:'creat'}})
            this.$router.push({name:'signUp'})
        },
        signIn(){
            gaAnalyze('lpSignIn');
            window.location.href = "https://" + window.location.host + '/userGroup/user-group/rgUser/redirectSignIn?service=1';
        },
        app(){
           gaAnalyze('lpStartIos');
        }
    }
}
</script>
<style lang="less" scoped>
.start{
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(51,51,51,0.72);
    top: 0;
    z-index: 1;
    .downLogos{
       display: none;
    }
    .width72{
        width: .72rem;;
    }
    .content{
        margin: 0 auto;
        color: #fff;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-60%);
        text-align: center;
        padding: 0 5%;
        .link{
            display: inline-block;
            text-align: left;
        }
        .title{
            font-size: 0.36rem;
            font-weight:bold;
            margin-bottom: .36rem;
            img{
                width: .64rem;
                display: inline-block;
                margin-right: 0.12rem;
                position: relative;
                top: 0.15rem;
            }
        }
        .nextTitle{
            font-size: 0.28rem;
            margin-bottom: .28rem;
        }
        p{
            font-size: 0.2rem;
            line-height: 0.32rem;
            margin-bottom: 0.24rem;
            padding-left: 0.3rem;
            position: relative;
            i{
                color: #1EC345;
                position: absolute;
                top: .05rem;
                left: 0;
                text-shadow: 0px 0px #1EC345;
                font-family: Arial;
                &:before{
                    font-weight: bold;
                    text-shadow: 0px 0px #1EC345;
                }
            }
        }
    }
    .start-btn{
        cursor: pointer;
        background: #1EC345;
        color: #fff;
        display: inline-block;
        padding: 0.12rem 0.24rem;
        border-radius: 0.4rem;
        font-size: 0.2rem;
        float: right;
    }
}
@media(max-width:1024px){
    .downLoad{
        display: none !important;
    }
    .start{
        .content{
            .title{
                font-size: 0.24rem;
                font-weight:bold;
                margin-bottom: .35rem;
            }
            .nextTitle{
                font-size: 0.18rem;
                margin-bottom: .28rem;
            }
            p{
                font-size: 0.14rem;
                line-height: 0.2rem;
                margin-bottom: 0.2rem;
                padding-left: 0.3rem;
                position: relative;
                i{
                    color: #1EC345;
                    position: absolute;
                    top: 0;
                    left: 0;
                    font-size: .19rem;
                    &:before{
                        font-weight: bold;
                    }
                }
            }
        }
        .start-btn{
            cursor: pointer;
            background: #1EC345;
            color: #fff;
            display: inline-block;
            padding: 0.08rem 0.14rem;
            border-radius: 0.32rem;
            font-size: 0.14rem;
            float: right;
        }
    }
}
@media(max-width:760px){
    .content{
        top: 0.2rem;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        padding: 0 5%;
    }
    .start{
        .content{
            .title{
                img{
                    width: .28rem;
                    display: inline-block;
                    margin-right: 0.12rem;
                    position: relative;
                    top: 0.05rem;
                }
            }
        }
    }

    .downLogos{
        display: block !important;
        position: fixed;
        top: .2rem;
        left: 0;
        width: 100vw;
        padding: 0 .2rem;
        z-index: 100;
       img{
            width: .36rem;
            display: inline-block;
            float: left;
        }
        .colorccc{
            color: #ccc;
            position: relative;
            top: .03rem;
        }
    }
}
</style>

